const flowConfig = {
  data() {
    return {
      // 定义流程类型开始
      TYPE_START: 10, // 开始节点
      TYPE_MISSION: 20, // 任务节点
      TYPE_APPROVE: 30, // 审批节点
      TYPE_ONLY: 40, // 排他节点
      TYPE_MULTIPLE: 50, // 并行网关节点
      TYPE_FUNC: 80, // 执行函数节点
      TYPE_END: 60, // 结束节点
      TYPE_REMARK: 70, // 备注节点
      TYPE_ROUTE: 100, // 路由
      TYPE_CUD: 90, // CUD节点
      // 定义流程类型结束
      // 定义控件权限开始
      INPUT_READONLY: 10, // 只读
      INPUT_EDITABLE: 20, // 可写
      INPUT_HIDDEN: 30, // 不使用
      INPUT_EXIST: 40, // 存在但不可见
      // 定义控件权限结束
      // 定义布局分列开始
      LAYOUT_COL_1: 10, // 一列
      LAYOUT_COL_2: 20, // 两列
      LAYOUT_COL_3: 30, // 三列
      // 定义布局分列结束
      // 定义接收类型开始
      RECEIVE_PERSON: 10, // 接收人
      RECEIVE_STRUCT: 20, // 接收部门
      RECEIVE_POST: 30, // 接收岗位
      RECEIVE_GROUP: 40, // 接收分组
      RECEIVE_ALL: 50, // 接收类型为全部
      RECEIVE_RELATION: 60, // 接收类型为选择关联字段
      // 定义接收类型结束
      // 定义流程分类开始
      FLOWTYPE_MYDEAl: 1, // 我的待办
      FLOWTYPE_MYSTART: 2, // 我的发起
      FLOWTYPE_DATA: 3, // 数据管理
      FLOWTYPE_HASDEAL: 4, // 已办事项
      // 定义流程分类结束
      // 定义CUD操作类型开始
      CUD_DEAL_ADD: 10, // 添加
      CUD_DEAL_UPDATE: 20, // 更新
      CUD_DEAL_DELETE: 30, // 删除
      CUD_DEAL_FUNC: 40, // 执行函数
      CUD_DEAL_COPY: 50, // 复制数据
      // 定义CUD操作类型结束
      // 定义CUD传参类型开始
      CUD_PARAM_CONST: 10, // 添加
      CUD_PARAM_FORMVALUE: 20, // 本表字段
      CUD_PARAM_DATE: 30, // 日期变量
      CUD_PARAM_NULL: 40, // 不传值
      CUD_PARAM_CUMULATIVE_CONSTANT: 60, // 累加常量
      CUD_PARAM_CUMULATIVE_VARIABLE: 50, // 累加变量
      CUD_PARAM__SUBTRACT_VARIABLE: 70, // 累减变量
      CUD_PARAM_TEMPLATE: 80, // 模板表单字段
      // 定义CUD传参类型结束
      // 定义CUD列表类型开始
      CUD_LIST_PROEXEC: 10, // 执行前提
      CUD_LIST_WHERE: 20 // 筛选条件
      // 定义CUD列表类型结束
    }
  }
}

export default flowConfig



// WEBPACK FOOTER //
// ./src/config/flowConfig.js